import React from 'react';
import styled from 'styled-components';

import { FjAvatar } from 'components/primitives';

export const Container = styled.div`
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-align: left !important;
  background: #1e1e1e;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: inherit;
  padding: 0 20px;
  box-sizing: border-box;
`;

export const LeftWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderAvatar = styled(FjAvatar)`
  justify-content: center;
  align-items: center;
  padding: 0;
  border: none;
`;

interface LogoImgProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  height?: number;
  width?: number;
}

// eslint-disable-next-line jsx-a11y/alt-text
export const LogoImg = styled(({ height, width, ...props }: LogoImgProps) => <img {...props} />)`
  height: ${(props: LogoImgProps) => props.height || 42}px;
  ${(props: LogoImgProps) => (props.width ? `width: ${props.width}px` : '')};
  margin-right: 10px;
`;

export const ChildrenContainer = styled.div`
  flex: 1;
  display: flex;
`;

export const TitleText = styled.h2`
  font-weight: 400;
`;
